
export const CREATE_NEW_ORG_REQUEST = "CREATE_NEW_ORG_REQUEST";
export const CREATE_NEW_ORG_SUCCESS = "CREATE_NEW_ORG_SUCCESS";
export const CREATE_NEW_ORG_FAIL = "CREATE_NEW_ORG_FAIL";
export const CREATE_NEW_ORG_RESET = "CREATE_NEW_ORG_RESET";

export const GET_MY_ORG_DETAILS_REQUEST = "GET_MY_ORG_DETAILS_REQUEST";
export const GET_MY_ORG_DETAILS_SUCCESS = "GET_MY_ORG_DETAILS_SUCCESS";
export const GET_MY_ORG_DETAILS_FAIL = "GET_MY_ORG_DETAILS_FAIL";
export const GET_MY_ORG_DETAILS_RESET = "GET_MY_ORG_DETAILS_RESET";

export const GET_ORG_LEVEL_CAMPAIGN_STATUS_REQUEST = "GET_ORG_LEVEL_CAMPAIGN_STATUS_REQUEST";
export const GET_ORG_LEVEL_CAMPAIGN_STATUS_SUCCESS = "GET_ORG_LEVEL_CAMPAIGN_STATUS_SUCCESS";
export const GET_ORG_LEVEL_CAMPAIGN_STATUS_FAIL = "GET_ORG_LEVEL_CAMPAIGN_STATUS_FAIL";
export const GET_ORG_LEVEL_CAMPAIGN_STATUS_RESET = "GET_ORG_LEVEL_CAMPAIGN_STATUS_RESET";